import { render, staticRenderFns } from "./SideNavMenu.vue?vue&type=template&id=cc983038&scoped=true&"
import script from "./SideNavMenu.vue?vue&type=script&lang=js&"
export * from "./SideNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideNavMenu.vue?vue&type=style&index=0&id=cc983038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc983038",
  null
  
)

export default component.exports